import { StyledMain } from "./styled";

export const Main = ({ children }) => {
  return (
    <StyledMain>
      {children}
    </StyledMain>
  );
};